import Seo from "@/components/layout/Seo";
import JsonLd from "@/components/layout/JsonLd";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import ServicesGrid from "@/components/marketing/ServicesGrid";
import SectionCTA from "@/components/marketing/SectionCTA";
import Reveal from "@/components/layout/Reveal";
import { buildBreadcrumb } from "@/lib/schema";

export default function PrestationsIndexPage() {
    return (
        <>
            <Seo
                title="Nos prestations"
                description="Découvrez l’ensemble des prestations RCPS Terrassement : terrassement, démolition, génie civil & voirie, enrobés, aménagements extérieurs et enrochage."
            />
            <JsonLd
                data={buildBreadcrumb([
                    { name: "Accueil", path: "/" },
                    { name: "Prestations", path: "/prestations" },
                ])}
                id="breadcrumb-prestations"
            />
            <section className="relative bg-navy-700 text-white overflow-hidden">
                <img
                    src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=2400&q=80"
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover opacity-40"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-navy-800/80 via-navy-700/70 to-navy-700" />
                <div className="absolute inset-0 bg-topo-dark opacity-40 mix-blend-overlay" />
                <div className="absolute inset-0 noise-overlay" />
                <div className="relative rcps-container pt-24 md:pt-28 pb-16 md:pb-24 max-w-4xl">
                    <Reveal>
                        <Breadcrumbs
                            variant="onImage"
                            trail={[
                                { name: "Accueil", path: "/" },
                                { name: "Prestations", path: "/prestations" },
                            ]}
                        />
                    </Reveal>
                    <Reveal delay={0.05}>
                        <p className="kicker text-white/80 mt-5"><span className="hairline bg-white/60" /> Nos prestations</p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h1 className="mt-4 font-heading text-4xl md:text-6xl font-semibold leading-[1.05] tracking-tight">
                            Cinq métiers maîtrisés en interne.
                        </h1>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-6 text-white/80 max-w-2xl text-base md:text-lg leading-relaxed">
                            Du terrassement initial à la finition des aménagements extérieurs, RCPS Terrassement
                            couvre l’ensemble de la chaîne technique avec un interlocuteur unique.
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="bg-white">
                <div className="rcps-container py-20 md:py-24">
                    <ServicesGrid />
                </div>
            </section>

            <SectionCTA />
        </>
    );
}
